var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.5263 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Personal Electronics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0432,10.9891c.2668,0,.483-.2162.483-.4831v-2.0091c0-.2669-.2163-.4831-.483-.4831h-.0003v-.8135c0-1.203-.9549-2.1806-2.1478-2.2223l-.4687-4.5675C10.4024.1773,10.2059,0,9.9714,0H2.9484C2.7103,0,2.5115.1813,2.4899.4184l-.4166,4.5633C.9154,5.0605,0,6.0224,0,7.2002v9.4843C0,17.8587.9099,18.8185,2.0628,18.9025l.4271,4.6788c.0216.2372.2205.4185.4585.4185h7.023c.2345,0,.4311-.1774.455-.4106l.4805-4.6829c1.1411-.0458,2.0593-.949,2.129-2.0838.0021,0,.004.0005.0062.0005h0c.2668,0,.483-.2162.483-.4831v-2.7768c0-.2664-.2159-.4824-.4822-.4829v-2.0913h.0003v.0002ZM9.5868.9925l.3737,3.9817H3.0287l.3987-3.9817s6.1594,0,6.1594,0ZM3.4274,23.0075l-.4102-4.0966h6.954l-.3845,4.0966H3.4274ZM12.0708,16.8254c0,.6378-.5171,1.155-1.1549,1.155H2.1271c-.6379,0-1.1549-.5172-1.1549-1.155V7.023c0-.638.5171-1.155,1.1549-1.155h8.7887c.6378,0,1.1549.517,1.1549,1.155v9.8025h.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.7758e7edc4d35f1b13890b273efeef3f.svg";
export { ForwardRef as ReactComponent };